// extracted by mini-css-extract-plugin
module.exports = {"header--sticky":"Header_header--sticky__WTBlo","header--fallback":"Header_header--fallback__yf0RX"};